module.exports = __WEBPACK_EXTERNAL_MODULE_52__;


//////////////////
// WEBPACK FOOTER
// external {"root":["dateFns","subDays"],"commonjs":"date-fns/sub_days/index","commonjs2":"date-fns/sub_days/index","amd":"date-fns/sub_days/index"}
// module id = 52
// module chunks = 0